import angular from "angular";
import { machineManufacturerLookupConfig } from "./machineManufacturer";

import { moduleName as recordsModuleName } from "../../../../records";
import { machineAreaLookupConfig } from "./area";
import { machineCabinetTypeLookupConfig } from "./cabinetType";
import { machineDenominationLookupConfig } from "./denomination";
import { machineGameTypeLookupConfig } from "./gameType";
import { machineLeaseFeeLookupConfig } from "./leaseFee";
import { machineLeaseTypeLookupConfig } from "./leaseType";
import { machineModelLookupConfig } from "./model";
import { machineThemeLookupConfig } from "./theme";
import { machineBankConfigLookupConfig } from "./bankConfig";

export const vsModuleName = "SlotTrak.Machines.Config.Lookups";

angular
  .module(vsModuleName, [recordsModuleName])
  .config(machineAreaLookupConfig)
  .config(machineCabinetTypeLookupConfig)
  .config(machineDenominationLookupConfig)
  .config(machineGameTypeLookupConfig)
  .config(machineLeaseFeeLookupConfig)
  .config(machineLeaseTypeLookupConfig)
  .config(machineManufacturerLookupConfig)
  .config(machineModelLookupConfig)
  .config(machineThemeLookupConfig)
  .config(machineBankConfigLookupConfig);
